import React, { Fragment, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { allProductTypesAction, clearErrors, createProductTypeAction, toggleProductTypesAction, deleteProductTypeAction } from '../../redux/actions/userActions';
import { toast } from 'react-toastify';
import HoverFullText from '../../elements/HoverToolKit';
import UpdateProductType from './UpdateProductType';
import api from '../../api';

const ProductTypes = () => {
    const dispatch = useDispatch();
    const { loading, error, message } = useSelector(state => state.createProductType);
    const { productTypes } = useSelector(state => state.allProductTypes);
    const [name, setName] = useState("");
    const [complexity_level, setComplexityLevel] = useState("");
    const [localTypes, setLocalTypes] = useState([]);

    useEffect(() => {
        if (productTypes) {
            setLocalTypes(productTypes);
        }
    }, [productTypes]);

    const handleMoveUp = async (index) => {
        if (index === 0) return;
        const newTypes = [...localTypes];
        const temp = newTypes[index];
        newTypes[index] = newTypes[index - 1];
        newTypes[index - 1] = temp;
        setLocalTypes(newTypes);
        await saveOrder(newTypes);
    };

    const handleMoveDown = async (index) => {
        if (index === localTypes.length - 1) return;
        const newTypes = [...localTypes];
        const temp = newTypes[index];
        newTypes[index] = newTypes[index + 1];
        newTypes[index + 1] = temp;
        setLocalTypes(newTypes);
        await saveOrder(newTypes);
    };

    const saveOrder = async (updatedTypes) => {
        const orders = updatedTypes.map((type, idx) => ({
            id: type.id,
            sort_order: idx
        }));
        try {
            const { data } = await api.put('/api/v1/update-product-type-order', { orders });
            if (data.success) {
                toast.success("Order updated successfully");
            }
        } catch (error) {
            toast.error(error.response?.data?.message || "Failed to update order");
        }
    };
    const [portal_commission, setPortalCommission] = useState("");
    const [showEditPage, setShowEditPage] = useState(false);
    const [selectedType, setSelectedType] = useState(null);
    const [pm_commission, setPmCommission] = useState("");


    const handleSubmit = (e) => {
        e.preventDefault();
        if (!name) return toast.error("Please enter product type name");
        if (!complexity_level) return toast.error("Please select complexity level");
        if (!portal_commission) return toast.error("Please enter portal commission");
        dispatch(createProductTypeAction({ name, complexity_level, portal_commission,pm_commission }));
    };

    useEffect(() => {
        if (message) {
            toast.success(message);
            dispatch({ type: "CREATE_PRODUCT_TYPE_RESET" });
            dispatch(allProductTypesAction());
            setName("");
            setComplexityLevel("");
            setPortalCommission("");
            setShowEditPage(false);
            setSelectedType(null);
        }
        if (error) {
            toast.error(error);
            dispatch(clearErrors());
        }
    }, [message, error, dispatch]);

    useEffect(() => { dispatch(allProductTypesAction()); }, [dispatch]);

    const handleToggle = (type_id, is_active) => {
        dispatch(toggleProductTypesAction(type_id, is_active));
    };

    const handleDelete = (id) => {
        if (window.confirm("Are you sure you want to delete this product type?")) {
            dispatch(deleteProductTypeAction(id));
        }
    };

    return (
        <Fragment>
            <form onSubmit={handleSubmit} className="mt-[2vmax]">
                <div className='grid grid-cols-1 lg:grid-cols-4 gap-[1.5vmax] items-end'>
                    <div className='flex flex-col'>
                        <label className='text-[0.85vmax] font-medium text-gray-500 uppercase tracking-wider'>Product Type Name <span className='text-red-500'>*</span></label>
                        <input
                            type="text"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            className='w-full px-[1vmax] py-[0.7vmax] bg-gray-50 border border-gray-100 rounded-lg outline-none focus:border-indigo-300 transition-colors text-[0.9vmax] mt-[0.5vmax] font-medium text-gray-700'
                            placeholder='ex. Text Review'
                        />
                    </div>
                    <div className='flex flex-col'>
                        <label className='text-[0.85vmax] font-medium text-gray-500 uppercase tracking-wider'>PM Commission (PKR) <span className='text-red-500'>*</span></label>
                        <input
                            type="number"
                            value={pm_commission}
                            onChange={(e) => setPmCommission(e.target.value)}
                            className='w-full px-[1vmax] py-[0.7vmax] bg-gray-50 border border-gray-100 rounded-lg outline-none focus:border-indigo-300 transition-colors text-[0.9vmax] mt-[0.5vmax] font-medium text-gray-700'
                            placeholder='ex. 900'
                        />
                    </div>
                    <div className='flex flex-col'>
                        <label className='text-[0.85vmax] font-medium text-gray-500 uppercase tracking-wider'>Portal Commission (PKR) <span className='text-red-500'>*</span></label>
                        <input
                            type="number"
                            value={portal_commission}
                            onChange={(e) => setPortalCommission(e.target.value)}
                            className='w-full px-[1vmax] py-[0.7vmax] bg-gray-50 border border-gray-100 rounded-lg outline-none focus:border-indigo-300 transition-colors text-[0.9vmax] mt-[0.5vmax] font-medium text-gray-700'
                            placeholder='ex. 200'
                        />
                    </div>
                    <div className='flex flex-col'>
                        <label className='text-[0.85vmax] font-medium text-gray-500 uppercase tracking-wider'>Complexity Level <span className='text-red-500'>*</span></label>
                        <div className="relative mt-[0.5vmax]">
                            <select
                                value={complexity_level}
                                onChange={(e) => setComplexityLevel(e.target.value)}
                                className='w-full pl-[1vmax] pr-[2vmax] py-[0.7vmax] bg-gray-50 border border-gray-100 rounded-lg outline-none focus:border-indigo-300 transition-colors text-[0.9vmax] appearance-none font-medium text-gray-700'
                            >
                                <option value="">--Select Complexity Level--</option>
                                <option value="easy">Easy</option>
                                <option value="medium">Medium</option>
                                <option value="complex">Complex</option>
                            </select>
                            <span className="absolute right-[1vmax] top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none">
                                <i className="fa-solid fa-chevron-down text-xs"></i>
                            </span>
                        </div>
                    </div>
                </div>
                <div className='flex justify-end gap-3 items-center mt-[2vmax]'>
                    <button className='bg-gray-100 hover:bg-gray-200 text-gray-700 px-[1.5vmax] py-[0.7vmax] rounded-lg text-[0.9vmax] font-bold transition-colors' type='reset'>Cancel</button>
                    <button 
                        className={`bg-indigo-600 hover:bg-indigo-700 text-white px-[2vmax] py-[0.7vmax] rounded-lg text-[0.9vmax] font-bold transition-colors shadow-sm disabled:opacity-50 disabled:cursor-not-allowed`} 
                        type='submit' 
                        disabled={loading || name === "" || complexity_level === ""}
                    >
                        {loading ? "Saving..." : "Save"}
                    </button>
                </div>
            </form>

            <div className="mt-[3vmax] overflow-x-auto">
                <h3 className="text-[1.2vmax] font-bold text-gray-800 mb-[1vmax]">Product Types List</h3>
                <div className="min-w-[1000px] border border-gray-200 rounded-xl overflow-hidden shadow-sm bg-white mb-[1.5vmax]">
                    {/* Header */}
                    <div 
                        className="grid bg-gray-50 py-[1vmax] items-center border-b border-gray-200"
                        style={{ gridTemplateColumns: 'minmax(0, 0.5fr) minmax(0, 1.5fr) minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr) minmax(0, 0.7fr) minmax(0, 2.5fr)' }}
                    >
                        <span className='text-center text-gray-600 font-bold uppercase text-[0.8vmax]'>No.</span>
                        <span className='text-center text-gray-600 font-bold uppercase text-[0.8vmax]'>Name</span>
                        <span className='text-center text-gray-600 font-bold uppercase text-[0.8vmax]'>PM Commission</span>
                        <span className='text-center text-gray-600 font-bold uppercase text-[0.8vmax]'>Commission</span>
                        <span className='text-center text-gray-600 font-bold uppercase text-[0.8vmax]'>Complexity Level</span>
                        <span className='text-center text-gray-600 font-bold uppercase text-[0.8vmax]'>Status</span>
                        <span className='text-center text-gray-600 font-bold uppercase text-[0.8vmax]'>Action</span>
                    </div>

                    {/* Rows */}
                    {localTypes?.length > 0 ? (
                        localTypes.map((type, index) => (
                            <div 
                                key={type.id} 
                                className="grid py-[1vmax] items-center border-b border-gray-100 last:border-b-0 hover:bg-gray-50 transition-colors"
                                style={{ gridTemplateColumns: 'minmax(0, 0.5fr) minmax(0, 1.5fr) minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr) minmax(0, 0.7fr) minmax(0, 2.5fr)' }}
                            >
                                <span className='text-center text-gray-500 font-bold text-[0.9vmax] flex items-center justify-center gap-2' >
                                    <span>{index + 1}</span>
                                    <div className="flex flex-col text-xs text-indigo-600">
                                        <button 
                                            type="button"
                                            onClick={() => handleMoveUp(index)} 
                                            disabled={index === 0}
                                            className="hover:text-indigo-800 disabled:text-gray-300"
                                        >
                                            <i className="fa-solid fa-chevron-up"></i>
                                        </button>
                                        <button 
                                            type="button"
                                            onClick={() => handleMoveDown(index)} 
                                            disabled={index === localTypes.length - 1}
                                            className="hover:text-indigo-800 disabled:text-gray-300"
                                        >
                                            <i className="fa-solid fa-chevron-down"></i>
                                        </button>
                                    </div>
                                </span>
                                <span className='text-center text-gray-800 font-bold text-[0.9vmax]'>
                                    <HoverFullText text={type.name} sliceLength={16} />
                                </span>
                                <span className='text-center text-gray-700 text-[0.9vmax]'>{type.portal_commission || "N/A"}</span>
                                <span className='text-center text-gray-700 text-[0.9vmax]'>{type.pm_commission || "N/A"}</span>
                                <span className='text-center flex justify-center'>
                                    <span className={`px-[0.8vmax] py-[0.2vmax] rounded-full text-[0.8vmax] font-bold uppercase tracking-wider
                                        ${type.complexity_level === "easy" ? "text-green-700 bg-green-50" : 
                                          type.complexity_level === "medium" ? "text-yellow-700 bg-yellow-50" : "text-red-700 bg-red-50"}`}
                                    >
                                        {type.complexity_level}
                                    </span>
                                </span>
                                <span className='text-center flex justify-center'>
                                    <span className={`px-[0.8vmax] py-[0.2vmax] rounded-full text-[0.8vmax] font-bold uppercase tracking-wider
                                        ${type.is_active === 1 ? 'text-green-700 bg-green-50' : "text-red-700 bg-red-50"}`}
                                    >
                                        {type.is_active === 1 ? "Active" : "Inactive"}
                                    </span>
                                </span>
                                <div className="text-center flex justify-center gap-2">
                                    <button className={`px-[1vmax] py-[0.4vmax] rounded-lg text-[0.8vmax] font-bold transition-colors text-white
                                        ${type.is_active === 0 ? "bg-emerald-600 hover:bg-emerald-700" : "bg-rose-600 hover:bg-rose-700"} 
                                        ${loading ? "opacity-50 cursor-not-allowed" : ""}`}
                                        onClick={() => handleToggle(type.id, type.is_active === 1 ? 0 : 1)}
                                        disabled={loading}
                                    >
                                        {type.is_active === 0 ? "Activate" : "Deactivate"}
                                    </button>
                                    <button className={`px-[1vmax] py-[0.4vmax] rounded-lg text-[0.8vmax] font-bold transition-colors text-white bg-indigo-600 hover:bg-indigo-700
                                        ${type.is_active === 0 ? "opacity-50 cursor-not-allowed" : ""} 
                                        ${loading ? "opacity-50 cursor-not-allowed" : ""}`}
                                        onClick={() => {
                                            if (type.is_active === 0) return;
                                            setSelectedType(type);
                                            setShowEditPage(true);
                                        }}
                                        disabled={loading || type.is_active === 0}
                                    >
                                        Edit
                                    </button>
                                    <button className={`px-[1vmax] py-[0.4vmax] rounded-lg text-[0.8vmax] font-bold transition-colors text-white bg-red-600 hover:bg-red-700
                                        ${loading ? "opacity-50 cursor-not-allowed" : ""}`}
                                        onClick={() => handleDelete(type.id)}
                                        disabled={loading}
                                    >
                                        Delete
                                    </button>
                                </div>
                            </div>
                        ))
                    ) : (
                        <div className="text-center text-[1.2vmax] text-gray-400 py-[2vmax]">No product types found</div>
                    )}
                </div>
            </div>
            {showEditPage && selectedType &&
                <UpdateProductType type={selectedType} setShowEditPage={setShowEditPage} setSelectedType={setSelectedType} />
            }

        </Fragment>
    );
};

export default ProductTypes;
